/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WebApiMembershipProductDtoCreateMembershipProductDto,
  WebApiMembershipProductDtoUpdateMembershipProductDto,
  WebApiModelsMembershipProduct,
} from '../models';
import {
    WebApiMembershipProductDtoCreateMembershipProductDtoFromJSON,
    WebApiMembershipProductDtoCreateMembershipProductDtoToJSON,
    WebApiMembershipProductDtoUpdateMembershipProductDtoFromJSON,
    WebApiMembershipProductDtoUpdateMembershipProductDtoToJSON,
    WebApiModelsMembershipProductFromJSON,
    WebApiModelsMembershipProductToJSON,
} from '../models';

export interface ApiMembershipProductIdDeleteRequest {
    id: number;
}

export interface ApiMembershipProductIdPutRequest {
    id: number;
    webApiMembershipProductDtoUpdateMembershipProductDto?: WebApiMembershipProductDtoUpdateMembershipProductDto;
}

export interface ApiMembershipProductPostRequest {
    webApiMembershipProductDtoCreateMembershipProductDto?: WebApiMembershipProductDtoCreateMembershipProductDto;
}

/**
 * 
 */
export class MembershipProductApi extends runtime.BaseAPI {

    /**
     */
    async apiMembershipProductGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiModelsMembershipProduct>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/MembershipProduct`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiModelsMembershipProductFromJSON));
    }

    /**
     */
    async apiMembershipProductGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiModelsMembershipProduct>> {
        const response = await this.apiMembershipProductGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiMembershipProductIdDeleteRaw(requestParameters: ApiMembershipProductIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiMembershipProductIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/MembershipProduct/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiMembershipProductIdDelete(requestParameters: ApiMembershipProductIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiMembershipProductIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiMembershipProductIdPutRaw(requestParameters: ApiMembershipProductIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiModelsMembershipProduct>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiMembershipProductIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/MembershipProduct/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiMembershipProductDtoUpdateMembershipProductDtoToJSON(requestParameters.webApiMembershipProductDtoUpdateMembershipProductDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiModelsMembershipProductFromJSON(jsonValue));
    }

    /**
     */
    async apiMembershipProductIdPut(requestParameters: ApiMembershipProductIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiModelsMembershipProduct> {
        const response = await this.apiMembershipProductIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiMembershipProductPostRaw(requestParameters: ApiMembershipProductPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiModelsMembershipProduct>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/MembershipProduct`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiMembershipProductDtoCreateMembershipProductDtoToJSON(requestParameters.webApiMembershipProductDtoCreateMembershipProductDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiModelsMembershipProductFromJSON(jsonValue));
    }

    /**
     */
    async apiMembershipProductPost(requestParameters: ApiMembershipProductPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiModelsMembershipProduct> {
        const response = await this.apiMembershipProductPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
